import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgStyle } from '@angular/common';

@Component({
  selector: 'app-filter-search-custom',
  standalone: true,
  imports: [InputTextModule, FormsModule, TranslateModule, NgStyle, NgClass],
  templateUrl: './filter-search-custom.component.html',
  styleUrl: './filter-search-custom.component.scss',
})
export class FilterSearchCustomComponent {
  @Input() value: string = '';
  @Input() backgroundColor!: string;
  @Output() valueChange = new EventEmitter<string>();

  onInputChange(event: any): void {
    this.valueChange.emit(this.value);
  }
}
